var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Unauthorized Domain(s)","sub-title":"These Domain(s) are unauthorized for the users of this organization"}},[_c('AddUnauthorizedDomain'),_c('UnauthorizedDomainList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }